import { ICase, initialCase, CheckCaseId } from "../../../../share/types/case/case";
import { IAuthState } from "../../../Auth/store/types";
import _ from 'lodash';
import { match } from "react-router";
import { IAgency } from "src/share/types/agency";


export const caseInitialState = {
    caseInfo: _.cloneDeep(Object.assign({}, initialCase)),
    submitted: false,
    loading: true,
    loadingMessage: "",
    isEditCase: false,
    imageUploadingStatus: {},
    caseSaved: false,
    beforeUpdate: null,
    caseIdStatus: CheckCaseId.NoCheck,
    agencies: [],
    targetAgency: "",
    transferCaseInformation: ""
};
export interface IImageStatusType {
    [key: string]: { status: 'UPLOADING' | 'SUCCESS' | 'FAILED' };
}
export interface ICaseUIState {
    caseInfo: ICase;
    submitted: boolean;
    loading: boolean;
    loadingMessage: string;
    isEditCase: boolean;
    imageUploadingStatus: IImageStatusType;
    caseSaved: boolean;
    beforeUpdate: ICase | null;
    component: number;
    caseIdStatus: CheckCaseId;
    isModalOpen: boolean;
    agencies: IAgency[],
    targetAgency: string,
    transferCaseInformation: string
};
export interface ICaseUIProps {
    auth: IAuthState;
    match: match<{ caseId: string }>
    history: any;
    location: any;
    permissionCase?: boolean,
    isAnETLCase: boolean
};